import { getIconByExtension } from 'utils/globalMethodes';
import { ChatListItem, Message } from '../types/types';
import { t } from 'i18next';
import moment from 'moment';

interface renderSentMessageProps {
  item: Message;
  user: AuthState;
  isRenderMore?: boolean;
  handelShowFile?: (
    title: string,
    id: number,
    mimetype: string,
  ) => Promise<void>;
  handeldeleteMessage?: (messageId: number) => void;
  openMedia?: (url: string, type: 'img' | 'pdf', title: string) => void;
}
export const renderSentMessage = (data: renderSentMessageProps): void => {
  const container = document.querySelector('.chat-messages-container');
  const received = data.item.user != data.user.userId;
  const chatClass = received
    ? 'chat-received tw-max-w-[85%] tw-min-w-[20%]'
    : 'chat-sent tw-max-w-[85%] tw-min-w-[20%] tw-ms-auto';

  const bubbleClass = received
    ? 'tw-bg-white tw-text-dark tw-border tw-border-light-gray tw-shadow-sm tw-rounded-[calc(var(--unit-minthr)*14)] tw-rounded-bl-[calc(var(--unit-minthr)*4)]'
    : 'tw-bg-primary tw-text-white tw-shadow-sm tw-rounded-[calc(var(--unit-minthr)*14)] tw-rounded-br-[calc(var(--unit-minthr)*4)]';
  const fileWrapClass = received
    ? 'tw-bg-white tw-text-dark'
    : 'tw-bg-primary tw-text-white';
  const iconColorClass = received ? 'tw-icon-gray' : 'tw-icon-white';

  const filesHtml = (data.item.files || [])
    .map(
      (file) => `
      ${
        !file.mimeType.startsWith('image/')
          ? `
      <div class="${fileWrapClass} tw-mt-2 tw-rounded-2xl tw-overflow-hidden vue-pdf">
        <a data-name="${file.name}" data-id="${file.id}" data-mimetype="${file.mimeType}" class="tw-flex tw-items-center tw-gap-2 tw-px-3 tw-py-2 tw-text-sm tw-no-underline tw-cursor-pointer chat-file">
          <img class="tw-w-6 tw-h-6 tw-shrink-0" src="/icons/${getIconByExtension(file.path)}" alt="">
          <div class="tw-flex-1 tw-min-w-0">
            <h6 class="tw-truncate tw-text-sm tw-font-medium tw-m-0">${file.name}</h6>
          </div>
          <img class="tw-w-4 tw-h-4 tw-shrink-0 ${iconColorClass}" src="/icons/${getVueIcon(file.mimeType)}" alt="">
        </a>
      </div>`
          : `<div class="${fileWrapClass} tw-mt-2 tw-rounded-2xl tw-overflow-hidden vue-image">
            <a data-name="${file.name}" data-id="${file.id}" data-mimetype="${file.mimeType}" class="tw-flex tw-items-center tw-no-underline tw-cursor-pointer chat-file">
              <img class="tw-rounded-2xl tw-max-w-full tw-block" src="/upload/GetChatDocument/${file.id}" alt="${file.name}">
            </a>
          </div>`
      }
    `,
    )
    .join('');

  if (container) {
    const prevScrollTop = container.scrollTop;
    const prevScrollHeight = container.scrollHeight;
    const wrapper = document.createElement('div');
    wrapper.className = `chat-item-message tw-mt-4 ${chatClass} ${!data.item.seen && !received ? 'tw-group' : ''}`;
    wrapper.setAttribute('data-id', data.item.id.toString());

    const justifyClass = received
      ? 'tw-justify-start tw-pl-7'
      : 'tw-justify-end tw-pr-7';
    const metaJustifyClass = received ? 'tw-justify-start' : 'tw-justify-end';
    const colAlignClass = received ? 'tw-items-start' : 'tw-items-end';

    const timeLabel = data.item.createdDate
      ? moment(data.item.createdDate).format('HH:mm')
      : data.item.date;

    // Time + read-receipt tucked inside the bubble (bottom-right), like the design.
    const inlineDeleteHtml =
      !data.item.seen && !received
        ? `<button class="tw-hidden tw-group-hover:tw-inline-flex tw-items-center tw-bg-transparent tw-border-none tw-p-0 tw-cursor-pointer chat-delete-message" data-id="${data.item.id}"><img class="tw-w-3 tw-h-3 tw-icon-white" src="/icons/delete.svg" alt=""></button>`
        : '';
    const inlineCheckHtml = !received
      ? `<img aria-hidden class="tw-w-3.5 tw-h-3.5 tw-icon-white tw-opacity-90" src="${data.item.seen ? '/icons/read.svg' : '/icons/check.svg'}" alt="">`
      : '';
    const inlineMetaHtml = `<span class="tw-inline-flex tw-items-center tw-gap-1 tw-shrink-0 tw-translate-y-[1px] tw-text-[calc(var(--unit-minthr)*10)] tw-leading-none ${received ? 'tw-text-dark-gray4' : 'tw-text-white tw-opacity-80'}">${inlineDeleteHtml}<span>${timeLabel}</span>${inlineCheckHtml}</span>`;

    const textBubbleHtml = data.item.message
      ? `<div class="${bubbleClass} tw-ps-3 tw-pe-4 tw-py-2 tw-text-[calc(var(--unit-minthr)*13.5)] tw-leading-snug tw-flex tw-items-end tw-gap-2"><span class="tw-whitespace-pre-wrap tw-break-words tw-text-left">${data.item.message}</span>${inlineMetaHtml}</div>`
      : '';

    // File-only messages keep the time on a muted row beneath the attachment.
    const belowDeleteHtml =
      !data.item.seen && !received
        ? `<button class="tw-bg-transparent tw-border-none tw-text-danger tw-text-[calc(var(--unit-minthr)*10.5)] tw-font-medium tw-p-0 tw-cursor-pointer tw-hidden tw-group-hover:tw-flex chat-delete-message" data-id="${data.item.id}">${t('delete')}</button>`
        : '';
    const belowCheckHtml = !received
      ? `<img aria-hidden class="tw-w-3.5 tw-h-3.5 ${data.item.seen ? 'tw-icon-info' : 'tw-icon-gray'}" src="${data.item.seen ? '/icons/read.svg' : '/icons/check.svg'}" alt="">`
      : '';
    const belowMetaHtml = !data.item.message
      ? `<div class="tw-mt-1 tw-px-1 tw-flex tw-items-center tw-gap-1.5 tw-text-[calc(var(--unit-minthr)*10.5)] tw-text-dark-gray4 ${metaJustifyClass}">${belowDeleteHtml}<span>${timeLabel}</span>${belowCheckHtml}</div>`
      : '';

    wrapper.innerHTML = `
      <div class="tw-flex ${justifyClass}">
        <div class="tw-max-w-full tw-flex tw-flex-col ${colAlignClass}">
          ${textBubbleHtml}
          ${filesHtml}
          ${belowMetaHtml}
        </div>
      </div>
    `;

    container.appendChild(wrapper);
    wrapper.querySelectorAll('.chat-file').forEach((link) => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const name = link.getAttribute('data-name');
        const mimeType = link.getAttribute('data-mimetype');
        if (data.openMedia && name && mimeType) {
          const id = Number(link.getAttribute('data-id'));
          handelShowFile(name, id, mimeType, data.openMedia);
        }
      });
    });

    wrapper.querySelectorAll('.chat-delete-message').forEach((msg) => {
      msg.addEventListener('click', (e) => {
        e.preventDefault();
        if (data.handeldeleteMessage) {
          const id = Number(msg.getAttribute('data-id'));
          data.handeldeleteMessage(id);
        }
      });
    });

    if (data.isRenderMore) {
      container.prepend(wrapper);
      const newScrollHeight = container.scrollHeight;
      container.scrollTop =
        prevScrollTop + (newScrollHeight - prevScrollHeight);
    } else {
      document.querySelector('.empty-conversation')?.remove();
      container.appendChild(wrapper);
      container.scrollTo({
        top: container.scrollHeight,
        behavior: 'smooth',
      });
    }
  }
};

export const getLastAction = (item: ChatListItem): string => {
  if (item?.lastAction != null) {
    const message = item.lastAction.message;
    if (message && message.length > 30) {
      return message.substring(0, 30) + '...';
    }
    if (message) {
      return message;
    }

    if (item.lastAction?.fileName) {
      return item.lastAction.fileName;
    }
  }
  return '';
};

export const handelActiveChat = (
  element: React.MouseEvent<HTMLDivElement, MouseEvent>,
): void => {
  document.querySelectorAll('.chat-user-item').forEach((el) => {
    el.classList.remove('active');
    el.classList.remove('tw-bg-primary-opacity');
  });
  const target = (element.target as Element).closest('.chat-user-item');
  if (target) {
    target.classList.add('active');
    target.classList.add('tw-bg-primary-opacity');
  }
};

const getVueIcon = (mimeType: string): string => {
  return mimeType.includes('pdf') ? 'eye.svg' : 'download.svg';
};

export const handelShowFile = async (
  title: string,
  id: number,
  mimetype: string,
  openMedia: (url: string, type: 'img' | 'pdf', title: string) => void,
): Promise<void> => {
  const url = `/upload/GetChatDocument/${id}`;
  if (mimetype === 'application/pdf' || mimetype.startsWith('image/')) {
    openMedia(url, mimetype.startsWith('image/') ? 'img' : 'pdf', title);
  } else {
    const link = document.createElement('a');
    link.href = url;
    link.download = title;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
};

export const handelShowLastMessage = (
  userCard: HTMLDivElement,
  message: string,
  isGroup: boolean,
): void => {
  const usersList = document.querySelector(
    `.chat-users-list${isGroup ? '.group' : '.users'}`,
  );

  if (userCard && usersList) {
    usersList.prepend(userCard);
  }
  const divDate = userCard?.querySelector('.date');
  const lastmessage = userCard?.querySelector('.lastmessage');
  const notification = userCard?.querySelector('.chat-item-notification');

  if (lastmessage && divDate) {
    divDate.innerHTML = moment().format('HH:mm').toString();
    if (
      notification &&
      !(
        notification
          .closest('.minthr-chat-user-item')
          ?.classList.contains('active') ||
        notification.closest('.chat-user-item')?.classList.contains('active')
      )
    ) {
      const currentValue = notification.getAttribute('data-value');
      const newValue = currentValue ? Number(currentValue) + 1 : 1;
      notification.setAttribute('data-value', newValue.toString());
      notification.innerHTML = newValue > 99 ? '99+' : newValue.toString();
    } else {
      if (notification) {
        notification.innerHTML = '';
      }
    }
    lastmessage.innerHTML = message;
  }
};
